export default function NoResultsBox() {
  return (
    <div className="py-4 px-7">
      <p className="text-[1.65rem] text-neutral-400 leading-normal">
        No matches found
      </p>
    </div>
  );
}
